import * as uuid from 'uuid'

const createLoggingContext = () => {
  const Guid = uuid.v1()
  const OriginatorUtcTimestamp = new Date().toUTCString()

  const correlationHeader = {
    CallChainId: Guid,
    OriginatorUtcTimestamp: OriginatorUtcTimestamp,
    ExtraHeaders: {
      CallChainFrontendId: Guid
    }
  }

  return btoa(JSON.stringify(correlationHeader))
}

export default createLoggingContext
